import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {SdkComponent} from "../../sdk/sdk.component";
import {CyClass} from "../../../../common/cy-classes";

const freeplayDirectiveConfig = getRewardsConfiguration();

export class FreeplayDetails extends OrbitComponent<{}> {
  render(): React.ReactNode {
    return (
      <div className={`cgp-directive-free_play ${CyClass('cy-free-play-container')}`}
           data-analytics={freeplayDirectiveConfig.analytics} />
    );
  }
}

export class MiniOrbitFreeplayDetails extends OrbitComponent<{}> {
  render(): React.ReactNode {
    let sdkProps={
      analytics: freeplayDirectiveConfig.analytics
    }
    return (
      <SdkComponent componentId='free_play' sdkProps={sdkProps}/>
    );
  }
}


function getRewardsConfiguration() {
  let rewardsAnalytics = {
    'OpenGame': {
      category: 'FP_Menu',
      action: 'Voucher',
      label: 'FP_Play_#{gameID}',
    },
    'SelectVoucher': {
      category: 'FP_Menu',
      action: 'Voucher',
      label: 'OpenVoucher#{voucherID}',
    }
  };

  return {
    analytics: JSON.stringify(rewardsAnalytics),
  };
}
